// @flow

import { View } from 'reshaped';

import { Field } from './Field';
import type { FormRow } from './types';

type Props = { row: FormRow };

export function FieldSet({ row }: Props): React.MixedElement {
  return (
    <View
      gap={{ s: 6, m: 4 }}
      direction={{ s: 'column', m: 'row' }}
      width="100%"
    >
      {row.map(field =>
        field.toRender || field.toRender === undefined ? (
          <Field field={field} key={field.name} />
        ) : null,
      )}
    </View>
  );
}
